import { Link } from 'react-router-dom'
import DefaultLayout from '../../layouts/DefaultLayout/DefaultLayout'

const Brief = () => {
  return <DefaultLayout>BRIEF</DefaultLayout>
}

export default Brief
